import { InventoryItem } from "@1games-ru/region-shared/dist/types/inventory/inventory";

// Функция для создания матрицы занятости
export default function createOccupiedMatrix(
  gridWidth: number,
  gridHeight: number,
  items: InventoryItem[],
): boolean[][] {
  const matrix = Array(gridHeight)
    .fill(null)
    .map(() => Array(gridWidth).fill(false));

  items.forEach((item) => {
    const xItem = item.position.x;
    const yItem = item.position.y;
    for (let y = yItem; y < yItem + item.size.height; y += 1) {
      for (let x = xItem; x < xItem + item.size.width; x += 1) {
        if (x < gridWidth && y < gridHeight) {
          matrix[y][x] = true;
        }
      }
    }
  });

  return matrix;
}
